'use strict';
var base = require('../product/base');
var baseDetails = require('base/product/detail');
var customUtil = require('../customUtil');

module.exports = {
    availability: base.availability,
    addToCart: base.addToCart,
    // removed updateAddToCart  for SI-38 requirment
    updateAttributesAndDetails: baseDetails.updateAttributesAndDetails,
    showSpinner: baseDetails.showSpinner,
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            response.container.data('video', response.data.product.pdpVideoID);
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0).length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                var productId = response.data.product.id;
                // BF might be using element text or data attribute which is also used by add to cart in PDP. Use different attribute for ATC.
                if ($('.product-detail.container:not(".bundle-item")').hasClass('bfx-price-product')) {
                    $('.product-detail:not(".bundle-item")').data('addtocart-pid', productId);
                    if (response.data.product.productType === 'variationGroup') {
                        productId = response.data.product.defaultVariantId;
                    }
                    $('.product-id').text(productId);
                    $('.product-detail:not(".bundle-item")').data('pid', productId);
                } else {
                    $('.product-id').text(productId);
                    $('.product-detail:not(".bundle-item")').data('pid', productId);
                }
            }
        });
    },
    updateAvailability: baseDetails.updateAvailability,
    selectAttribute: function() {
        $('body').on('click', '.product-description-container [data-attr="size"] button', function(e) {
            e.preventDefault();


            // if ($('.plp-atc').length && $('[data-page="Search-ShowResult"]').length == 0) {
            //     return;
            // }

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            // Back in Stock Notification
            $('.notify-sign-up').addClass('hide');
            $('#waitListJoin').removeClass('is-invalid');
            $(this).closest('.product-detail').find('.btn-container').removeClass('hide');

            if ($(this).hasClass('show-backinstock-module')) {
                // Show Back In Stock Module
                var $currentSelectedSize = $(this).siblings('[aria-checked="true"]');
                $(this).siblings('.size-attribute').attr('aria-checked', 'false');
                base.attributeSelect($(this).attr('data-url'), $productContainer, 'size');

                $(this).closest('.product-detail').find('.add-to-cart').addClass('hide');
                $(this).closest('.product-detail').find('.apple-pay-pdp').addClass('hide');
                $(this).closest('.product-detail').find('.backinstock-notify').removeClass('hide');
            } else {
                base.attributeSelect($(this).attr('data-url'), $productContainer, 'size');

                $(this).closest('.product-detail').find('.btn-container').removeClass('hide');
                $(this).closest('.product-detail').find('.add-to-cart').removeClass('hide');
                $(this).closest('.product-detail').find('.apple-pay-pdp').removeClass('hide');
                $(this).closest('.product-detail').find('.backinstock-notify').addClass('hide');
            }
        });

        $('button.add-to-cart-global').on('product:updateAddToCart', function (e, response) {
            if (response.product.readyToOrder) {
                $(this).attr('disabled', false);
            }
        });
    },
    sizeChart: function() {
        $(document).on('click', '.size-chart .sizeGuide-link', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this)
                .closest('.size-chart')
                .find('.size-chart-collapsible');
            var $productDescContainer = $(this)
                .closest('.product-description-container');
            if (!customUtil.isMobile()) {
                $productDescContainer.css({ top: '0rem' });
            }
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function(data) {
                        $prodSizeChart.append(data.content);

                        var modalOptions = {
                            keyboard: false,
                            backdrop: false
                        };

                        if ($('.modal-backdrop').length === 0) {
                            modalOptions.backdrop = 'static';
                        }

                        $('#pdp-sizeGuide').modal(modalOptions);

                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function(e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: baseDetails.copyProductLink,
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    pdpApplePay: function() {
        $('body').on('click', '.dw-apple-pay-button', function(e) {
            // Based on the product:beforeAddToCart event in pdpProductDetails.js
            var isPdpSet = $(this).closest('.product-set-detail').length;
            var selectedVal = $(this)
                .closest('.product-detail')
                .find('.select-size option:selected')
                .data('attr-value');
            if (!selectedVal && selectedVal !== 0 && !isPdpSet) {
                e.preventDefault();
                $('body').trigger('product:beforeAddToCart', this);
                $.spinner().stop();
                return false;
            }
        });

        $('body').on('product:updateAddToCart', function(e, response) {
            if (response.product.readyToOrder) {
                var applePayButton = $('.apple-pay-pdp', response.$productContainer);
                if (applePayButton.length !== 0) {
                    applePayButton.attr('sku', response.product.id);
                }
            }
        });
    },
    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            if (!$('.container.search-results').length) {
                $.spinner().start();
            }
        });
    },
    showPDPEDD: function () {
        var $eddText = $('.eddtext.productDetails');
        var $eddPidDiv = $eddText.find('.eddpid');
        var limit = 0;
        var timeInt;
        var unHideEdd = function () {
            if ($eddPidDiv.text().trim().length > 0 || limit > 100) {
                if ($eddText.hasClass('hide') && $eddPidDiv.text().trim().length > 0) {
                    $eddText.removeClass('hide');
                }
                clearTimeout(timeInt);
            } else {
                limit++;
                timeInt = setTimeout(unHideEdd, 100);
            }
        };
        unHideEdd();
    },
    videoThumbnail: function () {
        var videoId = $('.product-detail').data('video');
        if (videoId) {
            $.ajax({
                type: 'GET',
                url: 'https://vimeo.com/api/v2/video/' + videoId + '.json',
                dataType: 'json',
                success: function (data) {
                    var thumbnailUrl = data[0].thumbnail_large;
                    $('.video-thumbnail').attr('src', thumbnailUrl);
                    $('.pdp-main-video').attr('poster', thumbnailUrl);
                }
            });
        }
    },
    videoButton: function () {
        $(document).on('click', '.pdp-video-button', function () {
            var $videoButton = $('.pdp-video-button');
            var videoElement = $('.pdp-main-video')[0];
            if (videoElement && videoElement.paused) {
                videoElement.play();
                $videoButton.addClass('pause-button');
                $videoButton.removeClass('play-button');
            } else if (videoElement) {
                $videoButton.removeClass('pause-button');
                $videoButton.addClass('play-button');
                videoElement.pause();
            }
        });
    }
};
